export default "__VITE_ASSET__eFMjg6OS__"